import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { stripesConnect } from '@folio/stripes/core';
import { Col, Label } from '@folio/stripes/components';

import { okapi } from 'stripes-config';

import CreatePasswordModal from './Modals/CreatePasswordModal';
import ResetPasswordModal from './Modals/ResetPasswordModal';

import css from './CreateResetPasswordControl.css';

class CreateResetPasswordControl extends React.Component {
  static propTypes = {
    email: PropTypes.string,
    name: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    mutator: PropTypes.shape({
      resetPassword: PropTypes.shape({
        POST: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
    disabled: PropTypes.bool,
  };

  static manifest = Object.freeze({
    resetPassword: {
      type: 'okapi',
      path: 'bl-users/password-reset/link',
      fetch: false,
      throwErrors: false,
      /* kware start edit - Prevent stripesConnect from adding auto-generated 'id' field to POST payload */
      clientGeneratePk: false,
      /* kware end edit */
    },
  });

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      link: '',
      /* kware start edit - Add state for permission error */
      showPermissionError: false,
      /* kware end edit */
    };
  }

  closeModal = () => {
    /* kware start edit - Reset both modal and permission error states */
    this.setState({
      showModal: false,
      showPermissionError: false,
    });
    /* kware end edit */
  };

  handleSuccessResponse = ({ link }) => {
    this.setState({
      link: link.replace('http://localhost:3000', okapi.uiURL),
      showModal: true,
    });
  };

  handleLinkClick = () => {
    const {
      mutator: { resetPassword },
      userId,
    } = this.props;

    /* kware start edit - Send password reset link with proper error handling */
    const payload = { userId };
    /* kware end edit */

    resetPassword
      .POST(payload)
      .then(this.handleSuccessResponse)
      .catch((error) => {
        /* kware start edit - Handle permission error by checking status code or error message */
        const errorMessage = error?.message || error?.body || '';
        const isPermissionError =
          error?.httpStatus === 403 ||
          error?.status === 403 ||
          (error?.httpStatus === 500 &&
            errorMessage.includes('login.password-reset-action.post'));

        if (isPermissionError) {
          this.setState({
            showPermissionError: true,
            showModal: false,
          });
        } else {
          this.closeModal();
        }
        /* kware end edit */
      });
  };

  createPasswordModal = () => {
    const { showModal, link } = this.state;

    const { email } = this.props;

    return (
      <CreatePasswordModal
        isOpen={showModal}
        link={link.replace('http://localhost:3000', okapi.uiURL)}
        email={email}
        modalHeader={
          <FormattedMessage id="ui-users.extended.createPasswordModal.label" />
        }
        onClose={this.closeModal}
      />
    );
  };

  resetPasswordModal = () => {
    const { showModal, link } = this.state;

    const { email, name } = this.props;

    return (
      <ResetPasswordModal
        isOpen={showModal}
        link={link.replace('http://localhost:3000', okapi.uiURL)}
        email={email}
        name={name}
        modalHeader={
          <FormattedMessage id="ui-users.extended.resetPasswordModal.label" />
        }
        onClose={this.closeModal}
      />
    );
  };

  render() {
    const { disabled } = this.props;
    const { showPermissionError } = this.state;

    return (
      <Col xs={12} md={6}>
        <Label tagName="div">
          <FormattedMessage id="ui-users.extended.folioPassword" />
        </Label>
        {/* kware start edit - Show permission error message */}
        {showPermissionError && (
          <div style={{ color: 'red', marginBottom: '10px', fontSize: '14px' }}>
            <FormattedMessage id="ui-users.extended.sendResetPassword.permissionError" />
          </div>
        )}
        {/* kware end edit */}
        <button
          type="button"
          className={css.resetPasswordButton}
          onClick={this.handleLinkClick}
          disabled={disabled}
        >
          <FormattedMessage id="ui-users.extended.sendResetPassword" />
        </button>
        {this.resetPasswordModal()}
      </Col>
    );
  }
}

export default stripesConnect(CreateResetPasswordControl);
